// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WQP7Z","body":"styles_body__WNOuI"};